import { useCallback, useEffect, useState } from 'react'
import { getProjectDetailsV2, type ProjectDetailsV2Dto } from '@/lib/api/v2/projects'

export function useProjectDetailsV2(projectId: string | undefined) {
  const [data, setData] = useState<ProjectDetailsV2Dto | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  const refetch = useCallback(async () => {
    if (!projectId) return

    setIsLoading(true)
    setError(null)
    try {
      const d = await getProjectDetailsV2(projectId)
      setData(d)
    } catch (e) {
      setError(e)
      setData(null)
    } finally {
      setIsLoading(false)
    }
  }, [projectId])

  useEffect(() => {
    let cancelled = false
    if (!projectId) return

    setIsLoading(true)
    setError(null)

    getProjectDetailsV2(projectId)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [projectId])

  return { data, isLoading, error, refetch }
}
